import { Component, OnInit } from '@angular/core';
import { HomeTabDetailsModel } from '../../advisor-incentives/advisor-incentives.component';
import { CommonSharedModule } from '../../common/shared.module';
import { AllEventsComponent } from '../components/all-events/all-events.component';
import { EventsCountComponent } from '../components/events-count/events-count.component';
import { EventsPoeDocumentsComponent } from '../components/events-poe-documents/events-poe-documents.component';

@Component({
  selector: 'app-events-dashboard',
  templateUrl: './events-dashboard.component.html',
  styleUrls: ['./events-dashboard.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EventsCountComponent,
    EventsPoeDocumentsComponent,
    AllEventsComponent
  ]
})
export class EventsDashboardComponent implements OnInit {
  tabList!: HomeTabDetailsModel[];

  ngOnInit() {
    this.tabList = [
      new HomeTabDetailsModel(true, true),
      new HomeTabDetailsModel(),
      new HomeTabDetailsModel()
    ];
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
      tab.hasTabLoaded = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }

  get isEventCountSelected(): boolean {
    return this.tabList[0].isTabSelected;
  }
}
